<template>
    <div class="mediateBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <!--            我的案件-->
            <el-tab-pane label="我的案件" name="first">
                <myMediation v-if="activeName === 'first'"></myMediation>
            </el-tab-pane>
            <!--            被调解案件-->
            <el-tab-pane label="被调解案件" name="second">
                <beMediated v-if="activeName === 'second'"></beMediated>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import myMediation from './components/myMediation';
    import beMediated from './components/beMediated';

    export default {
        name: 'mediationCenter',
        components:{
            myMediation,
            beMediated
        },
        data() {
            return {
                activeName: 'first'
            };
        },
        methods: {
            handleClick(tab, event) {
                sessionStorage.setItem('mediationCenter', tab.name);
            }
        },
        created() {
            let name = sessionStorage.getItem('mediationCenter');
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if (name) {
                this.activeName = name;
            }
        }
    };
</script>

<style scoped>
    .mediateBox {
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-tabs__nav-wrap::after {
        background-color: transparent;
    }

    /deep/ .el-tabs__item {
        padding: 0px 30px;
    }
</style>
